import Sentry from "@similarweb/sentry-logger";

import type { INoTouchAddon } from "app/components/no-touch-purchase-modal/summary-modal/useNoTouchPurchaseSummaryModal";
import { getSingleDiscountCode } from "app/components/no-touch-purchase-modal/summary-modal/useNoTouchPurchaseSummaryModal";
import { useApiQuery } from "app/modules/api-client";

interface IUseNoTouchPurchaseDetailsQueryProps {
    selectedAddon: INoTouchAddon;
}

export const useNoTouchPurchaseDetailsQuery = ({ selectedAddon }: IUseNoTouchPurchaseDetailsQueryProps) => {
    const params = {
        templates: [
            {
                templateId: selectedAddon?.productTemplateId,
                quantity: selectedAddon?.quantity,
                countryFilterValue: selectedAddon?.countryFilterData?.countryCodeIso3,
                discountCode: getSingleDiscountCode(selectedAddon),
            },
        ],
    };

    return useApiQuery(
        {
            tag: "NoTouchAddonsPurchase",
            methodName: "notouchAddonsPurchaseInfoCreate",
            options: {
                enabled: () => !!selectedAddon,
                throwOnError: (e) => {
                    const error = e instanceof Error ? e : new Error(String(e), { cause: e });

                    Sentry.errorTracker({
                        message: "useNoTouchPurchaseDetailsQuery",
                        e: error,
                        params,
                    });
                    return false;
                },
            },
        },
        params,
    );
};
